/****************************************************************************************************************
*  ©2019 EdgeVerve Systems Limited, Bangalore, India. All Rights Reserved.
*
* The EdgeVerve proprietary software program ("Program"), is protected by copyrights laws, international treaties and
* other pending or existing intellectual property rights in India, the United States and other countries. The Program
* may contain / reference third party or open source components, the rights to which continue to remain with the
* applicable third party licensors or the open source community as the case may be and nothing here transfers the
* rights to the third party and open source components, except as expressly permitted. Any unauthorized reproduction,
* storage, transmission in any form or by any means (including without limitation to electronic, mechanical, printing,
* photocopying, recording or otherwise), or any distribution of this Program, or any portion of it, may result in
* severe civil and criminal penalties, and will be prosecuted to the maximum extent possible under the law.
*****************************************************************************************************************/
import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { config } from '../../ba-supplier-config';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { SuppUserService } from '../../services/supp-user.service';
import { CommonService } from '../../services/common.service';

@Component({
    selector: 'app-supp-manage-role',
    templateUrl: './supp-manage-role.component.html',
    styleUrls: ['./supp-manage-role.component.scss'],
    standalone: false
})
export class SuppManageRoleComponent implements OnInit {

  language = config.language;
  heading = 'supplier.userlist.managerole.title';
  cancel = 'supplier.userlist.managerole.cancel';
  submit = 'supplier.userlist.managerole.submit';
  title;
  roleForm: UntypedFormGroup;
  userRole;
  roleCodes;
  appList;
  userRoleMap = {};
  userAppMap = {};
  dropdownSettingsForRoles = {
    singleSelection: false,
    textField: 'itemName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    allowSearchFilter: true,
    classes: 'user-mulit-select multi-dropdown'
  };
  // dropdownSettingsForApps = {
  //   singleSelection: false,
  //   textField: 'itemName',
  //   selectAllText: 'Select All',
  //   unSelectAllText: 'UnSelect All',
  //   allowSearchFilter: true,
  //   classes: 'user-mulit-select multi-dropdown'
  // };

  dropdownSettingsForApps = {
  singleSelection: false,
  idField: 'id',
  textField: 'itemName',
  allowSearchFilter: true,
  //itemsShowLimit: 3,
  maxHeight: 200
};

  constructor(private _dialogRef: MatDialogRef<SuppManageRoleComponent>, @Inject(MAT_DIALOG_DATA) private _data: any,
    private _translate: TranslateService, private _formBuilder: UntypedFormBuilder, private userService: SuppUserService,
    private commonService: CommonService) {
  }
  ngOnInit() {
    this.userRole = this._data.userRole;
    this.roleCodes = this._data.roleCodes;
    this.appList = this._data.applist;    
    
    this._translate.get(this.heading).subscribe((result) =>
      this.title = result
    );
    this.setFormControls();

  }

  onNoClick(): void {
    this.close();
  }
  close() {
    this._dialogRef.close();
  }
  onAppDeSelect(deselected) {
  if (deselected.id === this.roleForm.controls.defaultApp.value) {

    this.roleForm.controls.defaultApp.setValue('');
    this.roleForm.controls.defaultApp.markAsTouched();
    this.roleForm.controls.defaultApp.markAsDirty();
    this.roleForm.controls.defaultApp.updateValueAndValidity();
  }
  console.log(this.roleForm.controls.defaultApp.errors);
console.log(this.roleForm.controls.defaultApp)
  }
  onAppDeSelectAll() {
  this.roleForm.controls.defaultApp.setValue('');
  this.roleForm.controls.defaultApp.markAsTouched();
  this.roleForm.controls.defaultApp.markAsDirty();
  this.roleForm.controls.defaultApp.updateValueAndValidity();
}
  
  updateRoles() {
    const data = {
      id: this.userRole.id,
      userCode: this.userRole.userCode,
      defaultApp: this.roleForm.controls.defaultApp.value,
      defaultPage: (this.roleForm.controls.defaultPage.value) ? this.roleForm.controls.defaultPage.value.trim() : ''
    };
    data['roles'] = this.userRole.roles.map(function (x) { return x.id; });
    data['apps'] = this.userRole.apps.map(function (x) { return x.id; });
    this.userService.updateUserRoles(data).toPromise()
      .then(response => {
        if (response.errorMessage) {
          this.commonService.openSnackBar(response.errorMessage);
        } else {
          this.commonService.openSnackBar(
            data.userCode + ' updated successfully'
          );
          this.close();
        }
      })
      .catch(error => {        
        this.commonService.openSnackBar(error.error.message);
      });
  }

  setFormControls() {
    this.roleForm = this._formBuilder.group({
      roles: [this.userRole.roles, [Validators.required]],
      apps: [this.userRole.apps, [Validators.required]],
      defaultApp: [this.userRole.defaultApp, [Validators.required]],
      defaultPage: [this.userRole.defaultPage, []]
    });
  }
}


